import { useState } from 'react';

import { PERFORMANCE_DASHBOARD_LINK_URL } from '~/modules/link-farm/components/LinkList/constants';
import { LinkPage } from '~/modules/link-farm/LinkPage';
import type { InternalLinkType } from '~/modules/link-farm/types';

import { SignInReminderModal } from '../../components/SignInReminderModal/SignInReminderModal';

export function MarketingPage() {
  const [showModal, setShowModal] = useState(false);

  const handleInternalLinkClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    type?: InternalLinkType,
  ) => {
    // Need to show a modal about possibly signing in to Databricks but only
    // for the performance dashboard.
    if (type === 'performanceDashboard') {
      const signInReminderModalViewCount = localStorage.getItem(
        'signInReminderModalViewCount',
      );

      const currentCount = signInReminderModalViewCount
        ? parseInt(signInReminderModalViewCount, 10)
        : 0;

      if (currentCount < 2) {
        event.preventDefault();
        event.stopPropagation();
        localStorage.setItem(
          'signInReminderModalViewCount',
          (currentCount + 1).toString(),
        );

        setShowModal(true);
      }
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <LinkPage
        category="marketing"
        onInternalLinkClick={handleInternalLinkClick}
      />
      <SignInReminderModal
        isOpen={showModal}
        onClose={handleModalClose}
        url={PERFORMANCE_DASHBOARD_LINK_URL}
      />
    </>
  );
}

MarketingPage.displayName = 'MarketingPage';
